/* eslint-disable no-template-curly-in-string */

import { Button, Col, Form, Input, Row } from 'antd';
import { FormProps } from 'antd/lib/form/Form';
import { I18n } from 'aws-amplify';
import * as React from 'react';

import { lang } from '../../i18n/lang';
import { CountrySelect } from '../CountrySelect';
import { SectorSelect } from '../SectorSelect';

import styles from './StartupSearchForm.module.less';

interface Props extends FormProps {
  loading?: boolean;
}

const maxLocationsItems = 5;
const maxSectorsItems = 5;

export function StartupSearchForm({
  loading,
  initialValues = { name: '', locations: [], sectors: [] },
  ...rest
}: Props) {
  return (
    <Form layout="vertical" initialValues={initialValues} hideRequiredMark {...rest}>
      <Row>
        <Col
          xs={{ span: 20, offset: 2 }}
          sm={{ span: 20, offset: 2 }}
          md={{ span: 12, offset: 6 }}
          lg={{ span: 12, offset: 6 }}
          className={styles.formItemCol}
        >
          <Form.Item
            hasFeedback
            name="name"
            rules={[{ required: true, message: I18n.get(lang.VALIDATOR_MSG_INPUT_SEARCH) }]}
          >
            <Input placeholder={I18n.get(lang.PLACEHOLDER_INPUT_SEARCH_STARTUP)} />
          </Form.Item>
        </Col>
      </Row>
      <Row className={styles.container} justify="space-around">
        <Col xs={20} sm={20} md={10} lg={10} className={styles.formItemCol}>
          <Form.Item
            hasFeedback
            labelCol={{ span: 24 }}
            label={
              <div>
                <b>{I18n.get(lang.LABEL_LOCATIONS_SEARCH)}</b>
                <br />
                <span className={styles.labelInfo}>
                  {I18n.get(lang.SELECT_LIMITED_OPTIONS).replace('${count}', maxLocationsItems)}
                </span>
              </div>
            }
            name="locations"
            rules={[{ required: true, message: I18n.get(lang.VALIDATOR_MSG_LOCATIONS_SEARCH) }]}
          >
            <CountrySelect maxItems={maxLocationsItems} />
          </Form.Item>
        </Col>

        <Col xs={20} sm={20} md={10} lg={10} className={styles.formItemCol}>
          <Form.Item
            hasFeedback
            labelCol={{ span: 24 }}
            label={
              <div>
                <b>{I18n.get(lang.LABEL_SECTORS_SEARCH_STARTUP)}</b>
                <br />
                <span className={styles.labelInfo}>
                  {I18n.get(lang.SELECT_LIMITED_OPTIONS).replace('${count}', maxSectorsItems)}
                </span>
              </div>
            }
            extra={I18n.get(lang.NO_SECTOR_SELECT_INFO)}
            name="sectors"
          >
            <SectorSelect maxItems={maxSectorsItems} />
          </Form.Item>
        </Col>

        <Col xs={20} sm={20} md={10} lg={10} className={styles.formItemCol}></Col>

        <Col xs={20} sm={20} md={10} lg={10}>
          <Button className={styles.actionButton} type="primary" htmlType="submit" loading={loading}>
            <Row>
              <Col span={24}>
                <b style={{ fontSize: 28, lineHeight: 0.1 }}>→</b>
              </Col>
              <Col span={24}>{I18n.get(lang.SEE_RESULT_BTN)}</Col>
            </Row>
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
